import React from 'react';
import { Menu, MenuButton, MenuItem, MenuPopover, MenuTrigger } from '@fluentui/react-components';
import DownloadIcon from '@mui/icons-material/Download';
import { FormattedMessage, useIntl } from 'react-intl';
import { APIRegistry } from '@55degrees/layout-r18';
import { reportMixPanel } from '@55degrees/consent-tracker';
import { useLocation } from 'react-router';
import { ProductFruitsReporter } from '../../Helpers/ProductFruitsInit';

function ExportDropdown() {
  const api = new APIRegistry();
  const location = useLocation();
  const isIndexPage = location.pathname === '/';

  const onSaveEmbeddedChartImageClick = () => {
    api.saveChartImage();
    ProductFruitsReporter.track('exportChartImage');
    reportMixPanel('Data Export', {
      Type: 'Image',
      'File Format': '.png',
    });
  };

  const onSaveCSVDataClick = () => {
    api.saveCSVData();
    ProductFruitsReporter.track('exportData');
    reportMixPanel('Data Export', {
      Type: 'Raw',
      'File Format': '.csv',
    });
  };

  const onSaveFilteredCSVDataClick = () => {
    api.saveFilteredCSVData();
    ProductFruitsReporter.track('exportData');
    reportMixPanel('Data Export', {
      Type: 'Filtered',
      'File Format': '.csv',
    });
  };

  return (
    <div>
      <Menu>
        <MenuTrigger>
          <MenuButton
            icon={<DownloadIcon fontSize="medium" />}
            shape="circular"
            appearance="subtle"
            size="large"
            id="a3-export"
            disabled={isIndexPage}
          />
        </MenuTrigger>
        <MenuPopover>
          <MenuItem onClick={onSaveEmbeddedChartImageClick}>
            <FormattedMessage
              id="export.menu.item.saveImage"
              defaultMessage="Save Chart Image (.png)"
              description="Menu Text"
            />
          </MenuItem>
          <MenuItem onClick={onSaveCSVDataClick}>
            <FormattedMessage
              id="export.menu.item.CSVraw"
              defaultMessage="Export Raw Data (.csv)"
              description="Menu Text"
            />
          </MenuItem>
          <MenuItem onClick={onSaveFilteredCSVDataClick}>
            <FormattedMessage
              id="export.menu.item.CSVfiltered"
              defaultMessage="Export Filtered Data (.csv)"
              description="Menu Text"
            />
          </MenuItem>
        </MenuPopover>
      </Menu>
    </div>
  );
}

export default ExportDropdown;
